/* Repair only the app's empty "more reviews" destination; all review controls stay app-owned. */
(function () {
  'use strict';
  if (window.ggReviewCarouselLinkReady) return;
  window.ggReviewCarouselLinkReady = true;
  var selector = '.jdgm-carousel-wrapper a.jdgm-carousel__more-reviews-button';
  function repair(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.matches(selector)) return;
    var href = anchor.getAttribute('href');
    if (href === null || href.trim() !== '') return;
    anchor.setAttribute('href', '/pages/all-reviews');
  }
  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches(selector)) repair(root);
    root.querySelectorAll(selector).forEach(repair);
  }
  function start() {
    scan(document);
    if (!document.body) return;
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') repair(record.target);
        else record.addedNodes.forEach(scan);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
